import type { IdentityUser } from '@libs/common-next';

export function getProfileCelebrationUserScope(user: IdentityUser): string | null {
    if (!user) {
        return null;
    }

    if (user.customerprofileid != null) {
        return String(user.customerprofileid);
    }

    if (user.loyaltyid != null) {
        return String(user.loyaltyid);
    }

    return user.sid || null;
}
